<template>
	<section class="view-venue-map padded alternate-panel">
		<ViewLayoutModuleHeader title="Where to find us">
			<a target="_blank" v-bind:href="mapUrl">Open Map ▲</a>
		</ViewLayoutModuleHeader>

		<section class="map" v-if="venueModel.id && venueModel.attributes.latitude">
			<iframe
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
				v-bind:src="mapUrl + '&output=embed'"
			></iframe>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays an embedded Google Map for a venue location.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueMap extends ViewBase {
		/**
		 * The venue model containing location data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * Generates the Google Maps URL for the venue location
		 *
		 * @return string
		 */
		protected get mapUrl(): string {
			const latitude = this.venueModel.getLatitude();
			const longitude = this.venueModel.getLongitude();
			const url = `https://maps.google.com/maps?q=${latitude},${longitude}&hl=en&z=14`;

			return url;
		}
	}
</script>

<style lang="scss">
	.view-venue-map {
		iframe {
			aspect-ratio: 1 / 1;
			border-radius: var(--border-radius);
			width: 100%;
		}
	}
</style>
